






































import Vue from 'vue'
import SeismicInspectionFileUpload from '@/components/SeismicInspectionFileUpload.vue'
import SeismicForm from '@/models/SeismicForm'
import SeismicFilesList from '@/components/SeismicFilesList.vue'
import SelectInspector from '@/components/TeamsManagement/SelectInspector.vue'
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex'

export default Vue.extend({
  name: 'Home',
  components: { SeismicInspectionFileUpload, SeismicFilesList, SelectInspector },
  data: () => {
    return {
      files: [] as Array<SeismicForm>,
      displayUserSelectionPopup: false
    }
  },
  computed: {
    ...mapGetters(['getSeismicForms', 'getSelectedInspectors', 'getInspectors', 'getSelectedCampaign'])
  },
  created () {
    this.SET_INDEXED_BD_REQUEST()
  },
  updated () {
    this.diagnoseData()
  },
  methods: {
    ...mapActions(['insertSeismicForm', 'updateSeismicForm', 'selectInspector', 'unselectInspector', 'uploadFile']),
    ...mapMutations(['SET_INDEXED_BD_REQUEST']),
    insertFile (file: SeismicForm) {
      // TODO: insert if not exists, update otherwise
      this.insertSeismicForm(file)
    },
    updateFile (file: SeismicForm) {
      this.updateSeismicForm(file)
    },
    diagnoseData () {
      console.log(this.getSelectedCampaign?.forms?.length)
    },
    dragoverHandler (ev: DragEvent) {
      ev.preventDefault()
    },
    dropHandler (ev: any) {
      ev.preventDefault()

      console.log('DROP', ev.dataTransfer)
      if (ev.dataTransfer.items) {
        // Use DataTransferItemList interface to access the file(s)
        for (let i = 0; i < ev.dataTransfer.items.length; i++) {
          // console.log('Items', ev.dataTransfer.files[i])
          // If dropped items aren't files, reject them
          if (ev.dataTransfer.items[i].kind === 'file') {
            const name = ev.dataTransfer.files[i].name
            ev.dataTransfer.files[i].text().then((data: string) => {
              this.handleOdataFileUpload(name, data)
            })
          }
        }
      } else {
        // Use DataTransfer interface to access the file(s)
        for (const element of ev.dataTransfer.files) {
          console.log('Files', element)
          element.text().then((data: string) => {
            this.handleOdataFileUpload(element.name, data)
          })
        }
      }
    },

    handleOdataFileUpload (fileName: string, fileContent: string) {
      if (!fileName.endsWith('.odata') && !fileName.endsWith('.odata.json')) {
        return ''
      }
      const content = JSON.parse(fileContent)

      if (content.application && content.application === 'ofis') {
        this.uploadFile({ fileName, fileContent: content })
        this.$router.push('import-campaign')
      }
    },

    uploadOdataFile (ev: any) {
      const file = ev.target.files[0]
      const reader = new FileReader()
      reader.addEventListener('loadend', () => {
        this.handleOdataFileUpload(ev.target.files[0].name, reader.result as string)
      })
      reader.readAsText(file)
    }
  }
})
